import { ClaimTypeCode, type ObjectType } from '@quromedical/fhir-common';
import * as yup from 'yup';

import type {
  ClaimTemplateBaseRequest,
  ClaimTemplateChargeLineQuantity,
} from './schema';

const templateChargeLineQuantitySchema = yup.object<
  ObjectType<ClaimTemplateChargeLineQuantity>
>({
  chargeLine: yup.string().required(),
  // We allow 0 to ensure that we can create a template with no charge lines, there for no claims are generated.
  quantity: yup.number().required().integer(),
});

const claimTypes = Object.values(ClaimTypeCode);

export const claimTemplateRequestSchema = yup.object<
  ObjectType<ClaimTemplateBaseRequest>
>({
  chargeLines: yup.array(templateChargeLineQuantitySchema).required().min(1),
  type: yup.string().equals(claimTypes).required(),
});
